import styled, { keyframes } from 'styled-components';

const overlayFadeIn = keyframes`
	from { opacity: 0 }
	to { opacity: 1 }
`;

const cardSlideIn = keyframes`
	from { opacity: 0; transform: translateY(8px) scale(0.97) }
	to { opacity: 1; transform: translateY(0) scale(1) }
`;

export const Overlay = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.5);
	z-index: 1000;
	display: flex;
	align-items: center;
	justify-content: center;
	animation: ${overlayFadeIn} 0.15s ease-out;
`;

export const ModalCard = styled.div`
	background: #FFFFFF;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	animation: ${cardSlideIn} 0.2s ease-out;

	@media only screen and (min-width: 601px) {
		width: 700px;
		height: 580px;
		border-radius: 8px;
	}

	@media only screen and (max-width: 600px) {
		width: 100%;
		height: 100%;
		border-radius: 0;
	}
`;

export const ModalHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 24px;
	border-bottom: 1px solid #D9E1E8;
	flex-shrink: 0;
`;

export const ModalTitle = styled.h3`
	font-weight: 700;
	font-size: 18px;
	color: #26282A;
	margin: 0;
`;

export const ModalLoadingWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
`;

export const ModalContent = styled.div`
	flex: 1;
	overflow-y: auto;

	@media only screen and (min-width: 601px) {
		padding: 24px;
	}

	@media only screen and (max-width: 600px) {
		padding: 16px;
	}

	font-size: 14px;
	line-height: 1.6;
	color: #4E5255;

	h2,
	h3 {
		color: #26282A;
		font-weight: 700;
		margin-bottom: 8px;
		margin-top: 16px;

		&:first-child {
			margin-top: 0;
		}
	}

	p {
		margin-bottom: 12px;
	}

	ul,
	ol {
		margin-bottom: 12px;
		padding-left: 20px;
	}

	li {
		margin-bottom: 4px;
	}

	a {
		color: #008CFF;
		text-decoration: none;

		&:hover {
			text-decoration: underline;
		}
	}
`;
